import { Component, OnInit } from '@angular/core';
import { AppSingle } from '../../app-single';
import { DependentMeepServerModel, TipoReembolso } from '../../models/dependent.model';
import { ActivatedRoute, Router } from '@angular/router';
import { DependentService } from '../../services/dependent.service';
import { NotificationService } from '../../notification/swal/notification.service';

@Component({
  selector: 'app-dependent-single',
  templateUrl: './dependent-single.component.html',
  styleUrls: ['./dependent-single.component.less']
})
export class DependentSingleComponent extends AppSingle implements OnInit {

  dependent: DependentMeepServerModel = new DependentMeepServerModel();
  dependentAlreadySearched = false;

  constructor(route: ActivatedRoute, private router: Router, private dependentsService: DependentService,
    private notificationService: NotificationService) {
    super(route);
  }

  ngOnInit() {
    this.dependentsService.getFromMeepServer(this.id, this.tipo)
    .then((_dependent: DependentMeepServerModel) => {
      this.dependent = _dependent;
      this.dependentAlreadySearched = true;
    })
    .catch((err) => {
      this.dependentAlreadySearched = true;
      this.notificationService.showErrorNotification(err.message);
    });
  }

  reembolsoHabilitado(tipoReembolso: TipoReembolso): boolean {
    return tipoReembolso.Id !== 0 && this.dependent.Saldo > 0;
  }

  goTo(where: string) {
    this.router.navigate([`general/${where}/${this.dependent.Tag}`]);
  }
  goToExtrato() {
    this.router.navigate([`general/extrato/${this.dependent.Tag}/${this.tipo}`]);
  }
  goToExtratoRotativo() {
    this.router.navigate([`general/extrato/${this.dependent.HistoricoAssociacaoId}/${this.tipo}`]);
  }
  goToRecarga() {
    this.router.navigate([`general/recarga/${this.dependent.Tag}/${this.tipo}`]);
  }
  goToNutricional() {
    this.router.navigate([`general/dependentesSingle/${this.dependent.Tag}/nutricional/${this.dependent.LocalClienteId}`]);
  }
  goToAssinaturas() {
    this.router.navigate([`general/dependentesSingle/${this.dependent.Tag}/assinaturas/${this.dependent.LocalClienteId}`]);
  }
  restricao() {
    this.router.navigate([`general/dependentesSingle/${this.dependent.Tag}/restricoes/${this.dependent.LocalClienteId}/${this.tipo}`]);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/dependent-single/dependent-single.component.ts